import React from "react"

interface Props {
  handleIsCallCenter: Function
}

function CallCenter({ handleIsCallCenter }: Props) {
  return (
    <div className="popupB">
      <div className="tit">
        <h3>고객센터안내</h3>
        <a
          href="#!"
          title="닫기"
          onClick={(e) => {
            e.preventDefault()
            handleIsCallCenter(false)
          }}
        >
          닫기
        </a>
      </div>
      <div className="txt">
        <ul>
          <li>
            <strong>가입안내 및 와우넷 사이트 문의</strong>
            <p>
              <i>-</i>1599-0700
            </p>
          </li>
          <li>
            <strong>방송창 오류 및 기술 문의</strong>
            <p>
              <i>-</i>1566-9367
            </p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default CallCenter
